import React from 'react'
import{AiFillStar} from 'react-icons/ai'
import {BsStarHalf} from 'react-icons/bs'
import {AiOutlineStar} from 'react-icons/ai'
    
const StarRating = ({value}) => {
    const stars = ['1','2','3','4','5','6'];
    
    if (value === 0) {
        return (
            <div className="flex flex-row">
                {stars.map(star => (
                    <AiOutlineStar className="text-gray-500 text-xl" key={star} />
                ))}
            </div>
        )
    }
    if (value === 1) {
      return (
        <div className="flex flex-row">
            {stars.slice(0,1).map(star => (
                <AiOutlineStar className="text-yellow text-xl" key={star} />
            ))}
        </div>
      )
    }


  return (
    <div className="flex flex-row" >
        {stars.slice(0,5).map(star => (
            <AiFillStar className="text-yellow text-xl" key={star} />
        ))}
    </div>
  )
}

export default StarRating